// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"styles_loadingContainer__rQEM8","ldsDefault":"styles_ldsDefault__3PCQW","lds-default":"styles_lds-default__3qHEo"};